/**
 * @file ShopPrimaryHost.tsx
 * @description Ячейка «Главный адрес» списка «Магазины» (phase19.28 этап А;
 * uiux-platform-shops §2): адрес в Юникоде (полный punycode — в подсказке)
 * и «+N адресов» второй строкой. Длинный адрес переносится по символам.
 */

import type { ShopListItem } from "../../../lib/api-platform-shops";
import { extraAddressesLabel, primaryHostLabel } from "../../../lib/platform/shop-list-filter";

export function ShopPrimaryHost({ shop }: { shop: ShopListItem }) {
  const extra = extraAddressesLabel(shop);
  const host = primaryHostLabel(shop);
  return (
    <span className="flex min-w-0 flex-col">
      <span className="break-all" title={shop.primaryHost ?? undefined}>{host}</span>
      {extra ? <span className="type-caption text-on-surface-variant">{extra}</span> : null}
    </span>
  );
}
